module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "loading",
      "mode": "out-in"
    }
  }, [_c('BeginLoading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BeginLoading),
      expression: "BeginLoading"
    }],
    on: {
      "BeginLoading": function($event) {
        _vm.BeginLoading = false
      }
    }
  })], 1), _vm._v(" "), _c('Topbar'), _vm._v(" "), _c('AsideMenu'), _vm._v(" "), _c('NContent'), _vm._v(" "), _c('ToTop'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "login"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "msg"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "newArticle"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "about"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-682aed19"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App/App.vue
// module id = 332
// module chunks = 4